import * as models from '../models';

export const httpClientProvider: models.HttpClientProvider = {};
